/* eslint-disable no-unused-vars */
import { Menu } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROUTE_PATH } from 'routes/route.constant';
import { SidebarWrapper } from './styled';

function Sidebar() {
  const { pathname } = useLocation();

  const [keySelected, setKeySelected] = useState('');
  const getItem = (label, key, icon, children, type) => ({
    key,
    icon,
    children,
    label,
    type,
  });

  const items = [
    getItem(
      <span>
        <Link to="#" className="inactive-link">
          アカウント管理
        </Link>
      </span>,
      'menu1',
      undefined,
      [
        getItem(
          <span>
            <Link to={ROUTE_PATH.MEMBER_MANAGEMENT}>会員管理</Link>
          </span>,
          ROUTE_PATH.MEMBER_MANAGEMENT
        ),
        getItem(
          <span>
            <Link to={ROUTE_PATH.ADMIN_REGISTER}>管理者登録</Link>
          </span>,
          ROUTE_PATH.ADMIN_REGISTER
        ),
      ]
    ),
    getItem(
      <span>
        <Link to={ROUTE_PATH.COURSE_MANAGEMENT}>養成コース登録</Link>
      </span>,
      ROUTE_PATH.COURSE_MANAGEMENT
    ),
    getItem(
      <span>
        <Link to="#" className="inactive-link">
          開催登録
        </Link>
      </span>,
      'menu2',
      undefined,
      [
        getItem(
          <span>
            <Link to={ROUTE_PATH.COURSE_SCHEDULE}> 養成コース</Link>
          </span>,
          ROUTE_PATH.COURSE_SCHEDULE
        ),
        getItem(
          <span>
            <Link to={ROUTE_PATH.SEMINAL_MANAGEMENT}>
              ブラッシュアップセミナー
            </Link>
          </span>,
          ROUTE_PATH.SEMINAL_MANAGEMENT
        ),
      ]
    ),
    getItem(
      <span>
        <Link to="#" className="inactive-link">
          全受講者リスト
        </Link>
      </span>,
      'menu3',
      undefined,
      [
        getItem(
          <span>
            <Link to={ROUTE_PATH.NEW_STUDENT_REGISTER}> 新規受講</Link>
          </span>,
          ROUTE_PATH.NEW_STUDENT_REGISTER
        ),
        getItem(
          <span>
            <Link to={ROUTE_PATH.STUDENT_RETAKETATION}>再受講</Link>
          </span>,
          ROUTE_PATH.STUDENT_RETAKETATION
        ),
      ]
    ),
    getItem(
      <span>
        <Link to={ROUTE_PATH.NEWS_MANAGEMENT}>NEWS管理</Link>
      </span>,
      ROUTE_PATH.NEWS_MANAGEMENT
    ),
    getItem(
      <span>
        <Link to={ROUTE_PATH.STUDIO_MANAGEMENT}>認定スタジオ管理</Link>
      </span>,
      ROUTE_PATH.STUDIO_MANAGEMENT
    ),
    getItem(
      <span>
        <Link to={ROUTE_PATH.FAQ_MANAGEMENT}>FAQ管理</Link>
      </span>,
      ROUTE_PATH.FAQ_MANAGEMENT
    ),
    getItem(
      <span>
        <Link to={ROUTE_PATH.FESTIVAL_MANAGEMENT}>フェスタ管理</Link>
      </span>,
      ROUTE_PATH.FESTIVAL_MANAGEMENT
    ),
    getItem(
      <span>
        <Link to={ROUTE_PATH.CEU_MANAGEMENT}>CEU管理</Link>
      </span>,
      ROUTE_PATH.CEU_MANAGEMENT
    ),
  ];

  useEffect(() => {
    setKeySelected(pathname);
  }, [pathname]);

  const listKeys = [
    {
      key: 'menu1',
      data: [ROUTE_PATH.MEMBER_MANAGEMENT, ROUTE_PATH.ADMIN_REGISTER],
    },
    {
      key: 'menu2',
      data: [ROUTE_PATH.COURSE_SCHEDULE, ROUTE_PATH.SEMINAL_MANAGEMENT],
    },
  ];

  return (
    <SidebarWrapper>
      <div style={{ padding: '32px 70px 15px 65px' }}>
        <img
          src={`${process.env.PUBLIC_URL}/images/icon.png`}
          width="115px"
          alt=""
        />
      </div>
      <Menu
        mode="inline"
        className="custom-menu"
        selectedKeys={[keySelected]}
        defaultOpenKeys={
          [
            listKeys?.filter((item) => item?.data?.includes(pathname))[0]?.key,
          ] || []
        }
        items={items}
        onClick={(e) => {
          setKeySelected(e.key);
        }}
      />
    </SidebarWrapper>
  );
}

export default Sidebar;
